import React, { Component } from 'react';
import update from 'immutability-helper';
import Loading from '../Loading.js'
import NamezzzFunction from '../../Fields/NamezzzFunction.js';
import NamezzzSector from '../../Fields/NamezzzSector.js';
import NamezzzOrganisation from '../../Fields/NamezzzOrganisation.js';
import FormMonthPicker from '../../Fields/FormMonthPicker.js';
import FormText from '../../Fields/FormText.js';
import FormList from '../../Fields/FormList.js'

import { getPersonWorkExperiences, postPersonWorkExperiences, deletePersonWorkExperiences } from '../../Api/UserActions.js'
import { getJsonItem, getJsonDate, getMonthYearString, isEmpty } from '../../Utilities/JsonFunctions.js'
import { getTranslation } from '../../Utilities/GetTranslation.js'
import { getCountries } from '../../Api/Namezzz.js';
import NamezzzCountry from '../../Fields/NamezzzCountry.js';
import { getWorkExperiencesFormList } from '../../Utilities/SnsFunctions.js';

declare var globalSns;

class WorkExperiences extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputCountryId: 1,
            inputOrganisationId: null,
            inputOrganisation: "",
            inputStart: "",
            inputLeave: "",
            inputFunctionId: null,
            inputFunctionSynonymId: null,
            inputFunction: "",
            inputSectorId: null,
            inputSectorSynonymId: null,
            inputSector: "",
            inputDescription: "",
            showValidation: false
        }
        
        this.deleteWorkExperience = this.deleteWorkExperience.bind(this);
        this.editWorkExperience = this.editWorkExperience.bind(this);
        this.resetWorkExperience = this.resetWorkExperience.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
        this.onFunctionChange = this.onFunctionChange.bind(this);
        this.onSectorChange = this.onSectorChange.bind(this);
        this.onOrganisationChange = this.onOrganisationChange.bind(this);
        this.addWorkExperience = this.addWorkExperience.bind(this);
        this.onStartChange = this.onStartChange.bind(this);
        this.onLeaveChange = this.onLeaveChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);
        this.onDescriptionBlur = this.onDescriptionBlur.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getCountries(globalSns.languageId, (data) => {
            this.setState({
                countries: data
            });
        });
        getPersonWorkExperiences(globalSns.languageId, (data) => {
            this.setState({
                personWorkExperiences: data
            });
        });
    }

    async isValidated() {
        if (isEmpty(this.state.inputStart) && isEmpty(this.state.inputFunction) && isEmpty(this.state.inputSector) && isEmpty(this.state.inputOrganisation)) {
            return true;
        }

        // We have to add the current values after navigating to other page
        var valid = this.addWorkExperience();
        return valid;
    }

    // editId: null => add experience
    // editId: value => modify experience
    addWorkExperience() {
        return new Promise(ok => {

            if (isEmpty(this.state.inputCountryId) || isEmpty(this.state.inputStart) || isEmpty(this.state.inputFunction) || isEmpty(this.state.inputSector) || isEmpty(this.state.inputOrganisation)) {
                this.setState({
                    showValidation: true
                })
                ok(false); // no workexperience is added
                return;
            }
    
            var id = this.state.editId;
    
            postPersonWorkExperiences(id, this.state.inputOrganisationId, this.state.inputOrganisation, 
                this.state.inputStart, this.state.inputLeave, this.state.inputFunctionId, this.state.inputFunctionSynonymId, this.state.inputFunction, 
                this.state.inputSectorId, this.state.inputSectorSynonymId, this.state.inputSector, this.state.inputCountryId, this.state.inputDescription, (newData) => {
                    
                    ok(true); // workexperience is added

                    if (newData.id === id) {
                        // Update workexperience
                        var item = getJsonItem(this.state.personWorkExperiences, "id", id);
                        var index = this.state.personWorkExperiences.indexOf(item);
                        
                        this.setState({
                            personWorkExperiences: update(this.state.personWorkExperiences, {[index]: {$set: newData}})
                        });
        
                        return;
                    }
        
                    // New workexperience
                    this.setState({
                        personWorkExperiences: update(this.state.personWorkExperiences, {$push: [newData]})
                    });
                });
    
            this.setState({
                editId: null,
                inputOrganisationId: null,
                inputOrganisation: "",
                inputStart: "",
                inputLeave: "",
                inputFunctionId: null,
                inputFunctionSynonymId: null,
                inputFunction: "",
                inputSectorId: null,
                inputSectorSynonymId: null,
                inputSector: "",
                inputDescription: "",
                showValidation: false
            });
        });
    }

    deleteWorkExperience(id) {
        deletePersonWorkExperiences(id, () => {
            var item = getJsonItem(this.state.personWorkExperiences, "id", id);
            var index = this.state.personWorkExperiences.indexOf(item);

            this.setState({
                personWorkExperiences: update(this.state.personWorkExperiences, {$splice: [[index, 1]]})
            })
        });
    }

    editWorkExperience(id) {
        var item = getJsonItem(this.state.personWorkExperiences, "id", id);

        if (item == null) {
            return;
        }

        this.setState({
            editId: id,
            inputCountryId: item.countryId,
            inputOrganisationId: item.seqOrg,
            inputOrganisation: item.org,
            inputStart: getMonthYearString(getJsonDate(item.datStart)),
            inputLeave: getMonthYearString(getJsonDate(item.datLeave)),
            inputFunctionId: item.functionId,
            inputFunctionSynonymId: item.functionSynonymId,
            inputFunction: item.function,
            inputSectorId: item.sectorId,
            inputSectorSynonymId: item.sectorSynonymId,
            inputSector: item.sector,
            inputDescription: item.description            
        });
    }

    resetWorkExperience(e) {
        this.setState({
            editId: null,
            inputOrganisationId: null,
            inputOrganisation: "",
            inputStart: "",
            inputLeave: "",
            inputFunctionId: null,
            inputFunctionSynonymId: null,
            inputFunction: "",
            inputSectorId: null,
            inputSectorSynonymId: null,
            inputSector: "",
            inputDescription: ""
        });
    }

    onCountryChange(id) {
        this.setState({
            inputCountryId: id
        });
    }

    onFunctionChange(e, id, synonymId) {     
        this.setState({
            inputFunction: e.target.value,
            inputFunctionId: id,
            inputFunctionSynonymId: synonymId
        });
    }

    onSectorChange(e, id, synonymId) {
        this.setState({
            inputSector: e.target.value,
            inputSectorId: id,
            inputSectorSynonymId: synonymId
        });
    }

    onOrganisationChange(e, id) {
            
        this.setState({
            inputOrganisation: e.target.value,
            inputOrganisationId: id
        });
    }

    onStartChange(e) {
        this.setState({
            inputStart: e
        });
    }

    onLeaveChange(e) {
        this.setState({
            inputLeave: e
        });
    }

    onDescriptionChange(e) {
        this.setState({
            inputDescription: e.target.value
        })
    }

    onDescriptionBlur(e) {

    }

    render() {
        
        if (this.state.personWorkExperiences == null || this.state.countries == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div>
                <h4 className="legend-title">{getTranslation("sns.webparts.workexperiences.cat")}</h4>

                <p><em>{getTranslation("sns.webparts.workexperiences.sub")}</em></p>
                
                <FormList values={getWorkExperiencesFormList(this.state.personWorkExperiences)} title={getTranslation("sns.webparts.workexperiences.selected")} isUserData={true}
                    showEdit={true} showDelete={true} highlightId={this.state.editId} onDelete={this.deleteWorkExperience} onEdit={this.editWorkExperience} />

                <NamezzzCountry id="inputCountry" text={getTranslation("sns.webparts.jobapply.experiences")}
                    languageId={globalSns.languageId} countries={this.state.countries}
                    countryId={this.state.inputCountryId} onCountryChange={this.onCountryChange} />
                <div className="tr">
                    <div className="FieldLabel td">
                        <label htmlFor="inputFunction">{getTranslation("sns.webparts.workexperiences.function")}
                            <span className="required-mark">*</span>
                        </label>                    
                    </div>
                    <NamezzzFunction id="inputFunction" seqlang={globalSns.languageId}
                        value={this.state.inputFunction}
                        showValidation={this.state.showValidation}
                        validationText={isEmpty(this.state.inputFunction) ? getTranslation("basicform.erroremptyvalue"): null}
                        onChange={this.onFunctionChange} />         
                </div>
                <div className="tr">
                    <div className="FieldLabel td">
                        <label htmlFor="inputSector">{getTranslation("sns.webparts.workexperiences.sector")}
                            <span className="required-mark">*</span>
                        </label>                    
                    </div>
                    <NamezzzSector id="inputSector" seqlang={globalSns.languageId}
                        value={this.state.inputSector} 
                        showValidation={this.state.showValidation}
                        validationText={isEmpty(this.state.inputSector) ? getTranslation("basicform.erroremptyvalue"): null}                        
                        onChange={this.onSectorChange} /> 
                </div>                               
                <NamezzzOrganisation id="inputOrganisation" 
                    text={getTranslation("sns.webparts.workexperiences.organisation")} required={true}
                    showValidation={this.state.showValidation}
                    validationText={isEmpty(this.state.inputOrganisation) ? getTranslation("basicform.erroremptyvalue"): null}                    
                    value={this.state.inputOrganisation} onChange={this.onOrganisationChange} />
                <FormMonthPicker id="inputStart"
                    text={getTranslation("sns.webparts.workexperiences.start")} 
                    required={true}
                    showValidation={this.state.showValidation}
                    validationText={isEmpty(this.state.inputStart) ? getTranslation("basicform.erroremptyvalue"): null}                                        
                    value={this.state.inputStart} 
                    onMonthChange={this.onStartChange} />
                <FormMonthPicker id="inputLeave"
                    text={getTranslation("sns.webparts.workexperiences.leave")}
                    showCheckbox={true} 
                    textCheckbox={getTranslation("sns.webparts.workexperiences.untilnow")}
                    value={this.state.inputLeave} 
                    onMonthChange={this.onLeaveChange} />
                <FormText id="inputDescription"
                    rows={5} text={getTranslation("sns.webparts.workexperiences.description")} value={this.state.inputDescription}
                    onChange={this.onDescriptionChange} />

                <div className="tr text-right col-md-8 button-wrapper">
                    <input type="button" className="FormButton btn btn-primary blue act" value={getTranslation("sns.webparts.workexperiences.reset")} id="actreset" onClick={this.resetWorkExperience} />
                    <input type="button" className="FormButton btn btn-primary blue act" value={getTranslation("sns.webparts.workexperiences." + ((this.state.editId == null) ? "add" : "edit"))} id="actsave" onClick={this.addWorkExperience} />
                </div>
            </div>
        );
    }
}

export default WorkExperiences;


// WEBPACK FOOTER //
// ./src/Components/Tabs/WorkExperiences.js